import { Link } from "react-router-dom";

export default function HeroBanner() {
  return (
    <div className="card" style={{ marginBottom: '24px', background: 'var(--header-footer)', color: 'var(--text-primary)' }}>
      <h2>Festive & Everyday Essentials</h2>
      <p>
        From authentic Rudraksha to Aquarium gear and Ayurveda, find everything you need in one place.
      </p>
      <Link to="/shop" className="btn-primary" style={{ display: 'inline-block', marginTop: '12px' }}>
        Shop Now
      </Link>
    </div>
  );
}
